import { Button } from "../ui/button";
import { Input } from "../ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";

export function ResetPinDialog({
  open,
  onOpenChange,
  newPin,
  setNewPin,
  confirmPin,
  setConfirmPin,
  onSubmit,
  loading,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-white font-['Outfit']">
            Reset Family PIN
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Enter a new PIN to secure your family hub.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <label className="text-sm text-slate-400 mb-1 block">New PIN</label>
            <Input
              type="password"
              value={newPin}
              onChange={(e) => setNewPin(e.target.value.replace(/\D/g, ""))}
              placeholder="Enter new PIN (min 4 digits)"
              maxLength={6}
              className="bg-slate-950 border-slate-800"
              data-testid="new-pin-input"
            />
          </div>

          <div>
            <label className="text-sm text-slate-400 mb-1 block">
              Confirm PIN
            </label>
            <Input
              type="password"
              value={confirmPin}
              onChange={(e) =>
                setConfirmPin(e.target.value.replace(/\D/g, ""))
              }
              placeholder="Confirm new PIN"
              maxLength={6}
              className="bg-slate-950 border-slate-800"
              data-testid="confirm-pin-input"
            />
          </div>

          <div className="flex gap-3 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1 border-slate-700"
              data-testid="pin-reset-cancel"
            >
              Cancel
            </Button>
            <Button
              onClick={onSubmit}
              disabled={loading}
              className="flex-1 bg-indigo-600 hover:bg-indigo-500"
              data-testid="pin-reset-submit"
            >
              {loading ? "Resetting..." : "Reset PIN"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
